import styled from 'styled-components';
import Title from 'js/components/core/Title';
import { blueColor } from 'js/config/style';

export default styled.div`
  display: flex;
  flex-direction: column;
`;
